module.exports = __webpack_public_path__ + "static/media/KamranQamarTanoli.6fd9835e.jpg";